"use client";

import { createContext, type ReactNode, use } from "react";

const BreadcrumbsVisibilityContext = createContext<boolean>(false);

export const BreadcrumbsVisibilityProvider = ({
	hidden,
	children,
}: {
	hidden: boolean;
	children: ReactNode;
}) => (
	<BreadcrumbsVisibilityContext.Provider value={hidden}>
		{children}
	</BreadcrumbsVisibilityContext.Provider>
);

export const useHideBreadcrumbs = () => use(BreadcrumbsVisibilityContext);

export const HideBreadcrumbsGate = ({ children }: { children: ReactNode }) => {
	const hidden = useHideBreadcrumbs();
	return hidden ? null : children;
};
